<template>
  <div class="space-center index-wrapper">
    <div class="space-center index-content">
      <div class="home-content">
        <!-- Logo - 使用租户配置 -->
        <div class="logo-area">
          <img class="logo" :src="tenantConfig.logo" alt="logo" />
        </div>
      </div>

      <!-- 主体 -->
      <div class="box-wrap full-width negative-margin-top">
        <!-- 登录组件 -->
        <LoginComponent ref="loginRef" :updateAgreeTerms="updateAgreeTerms" :agree-terms="agreeTerms" />
      </div>
    
    </div>
    <div class="company-info">
      
       <div class="agreement-section" >
        <label class="agreement-checkbox">
          <input type="checkbox" v-model="agreeTerms" />
          <span class="checkmark"></span>
          <span class="label-text">
            我已阅读并同意
            <span class="link" @click.stop="showAgreement">《用户协议》</span>
            和
            <span class="link" @click.stop="showPrivacy">《隐私政策》</span>
          </span>
        </label>
      </div>
      <div class="company-info-title">上海合宙通信科技有限公司</div>
    </div>
   
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { setLang } from '@/i18n'
import { getCurrentTenant } from '@/utils/tenant'
import { detectPlatform } from '@/utils/platform'

// @ts-ignore: script setup components are valid default exports in Vue 3
import LoginComponent from './login/index.vue'
import { isMiniProgram } from 'd3components/src/utils/tools'

const { t } = useI18n({ useScope: 'global' })
const router = useRouter()

// 获取当前租户配置
const tenantConfig = getCurrentTenant()

const LANGUAGES = {
  CHINESE: 'zh-cn',
  ENGLISH: 'en-us',
} as const

// 响应式数据
const isChineseLanguage = ref(true)
const agreeTerms = ref(false)

const showAgreement = () => {
  router.push('/protocol')
}

const showPrivacy = () => {
  router.push('/privacy')
}
const updateAgreeTerms = (value: boolean) => {
  agreeTerms.value = value
}
// 子组件引用
const loginRef = ref<any>(null)

const goToSetting = (): void => {
  router.push('/server-config')
}

const switchToChinese = () => {
  if (!isChineseLanguage.value) {
    setLang(LANGUAGES.CHINESE)
    isChineseLanguage.value = true
  }
}

const switchToEnglish = () => {
  if (isChineseLanguage.value) {
    setLang(LANGUAGES.ENGLISH)
    isChineseLanguage.value = false
  }
}
</script>

<style scoped lang="scss">
$primary-color-login-text: rgb(17, 109, 238);

$text-secondary: #8a94a6;
$accent-color: $primary-color-login-text;
$animation-duration-fast: 0.25s;
$animation-duration-normal: 0.55s;
$animation-duration-slow: 3s;
$logo-size: 150px;
$flag-size: 20px;
$gap-small: 0.3rem;
$gap-normal: 0.75rem;
$gap-large: 0.9rem;
$border-radius-full: 50%;
$radius-sm: 4px;
$transition-base: 0.3s ease;
$font-weight-medium: 500;

  // ===== 公司信息（绝对定位在页面底部）=====
  .company-info {
    text-align: center;
    font-size: 0.85rem;
    opacity: 0.7;
    letter-spacing: 0.05em;
    user-select: none;
    white-space: nowrap;
    z-index: 1;
    margin-bottom: 80px;
    .company-info-title{
          color: $text-secondary;
    }

    // 用户协议区域
    .agreement-section {
      // margin-bottom: 1rem;
      padding: 0 20px;

      .agreement-checkbox {
        display: flex;
        align-items: flex-start;
        cursor: pointer;
        user-select: none;
        justify-content: center;

        input[type='checkbox'] {
          display: none;
        }

        .checkmark {
          width: 24px;
          height: 24px;
          display: inline-block;
          min-width: 24px;
          border: 2px solid #d1d5db;
          border-radius: $radius-sm;
          margin-right: 8px;
          margin-top: 2px;
          position: relative;
          transition: all $transition-base;
          background: #fff;

          &::after {
            content: '✓';
            position: absolute;
            top: 50%;
            left: 50%;
            font-size: 12px;
            font-weight: bold;
            color: #fff;
            transform: translate(-50%, -50%) scale(0);
            transition: transform 0.2s ease;
          }
        }

        input[type='checkbox']:checked + .checkmark {
          border-color: $accent-color;
          background: $accent-color;

          &::after {
            transform: translate(-50%, -50%) scale(1);
          }
        }

        .label-text {
          font-size: 0.85rem;
          color: $text-secondary;
          font-weight: $font-weight-medium;
          line-height: 1.5;

          .link {
            color: $accent-color;
            font-weight: 600;
            cursor: pointer;
            text-decoration: none;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.space-center {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.flex-center {
  display: flex;
  align-items: center;
}

.full-width {
  width: 100%;
}

.negative-margin-top {
  margin-top: -20%;
}

.box-wrap {
  user-select: none;
}

.footer-setting {
  justify-content: center;
  margin-top: 0.25rem;
}

.index-wrapper {
  height: 100vh;
  width: 100vw;
  overflow: auto;
  position: relative;
  background-color: var(--color-body) !important;

  .index-content {
    width: 100%;
    position: relative;
    z-index: 1;
    margin-top: 20px;
  }

  .index-footer {
    margin-bottom: 5%;
    // color: $text-secondary;
    color: var(--color-text);
    font-size: 0.85rem;

    & > p {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: $gap-large;
      margin-top: 2%;
    }

    .lang-switch {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: $gap-normal;
      margin-right: $gap-normal;

      .lang-item {
        width: 40px;
        height: 40px;
        border-radius: $border-radius-full;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all $animation-duration-normal ease;
        border: 2px solid transparent;

        .flag {
          font-size: $flag-size;
          line-height: 1;
        }

        &:hover {
          transform: scale(1.1);
          background: rgba(255, 255, 255, 0.9);
        }

        &.active {
          border-color: $accent-color;
        }
      }
    }
  }
}

.home-content {
  width: 100%;
  height: 380px;

  .logo-area {
    margin-top: 50px;
    display: flex;
    justify-content: center;

    .logo {
      width: $logo-size;
      height: $logo-size;
      object-fit: contain;
      animation: logoFloat $animation-duration-slow ease-in-out infinite;
    }
  }
}

@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
</style>
